module.exports = __webpack_public_path__ + "img/JNY-HCP-desk_0785.f3a2a426.jpg";